var map = {
	"./AboutAir": [
		44708,
		3,
		4708
	],
	"./AboutAir.json": [
		44708,
		3,
		4708
	],
	"./AboutClothings": [
		9609,
		3,
		9609
	],
	"./AboutClothings.json": [
		9609,
		3,
		9609
	],
	"./AboutFoods": [
		38825,
		3,
		8825
	],
	"./AboutFoods.json": [
		38825,
		3,
		8825
	],
	"./AboutMaterials": [
		40274,
		3,
		274
	],
	"./AboutMaterials.json": [
		40274,
		3,
		274
	],
	"./AboutPlants": [
		14366,
		3,
		4366
	],
	"./AboutPlants.json": [
		14366,
		3,
		4366
	],
	"./AboutShelter": [
		74945,
		3,
		4945
	],
	"./AboutShelter.json": [
		74945,
		3,
		4945
	],
	"./AboutWater": [
		42519,
		3,
		2519
	],
	"./AboutWater.json": [
		42519,
		3,
		2519
	],
	"./AboutWeather": [
		13100,
		3,
		3100
	],
	"./AboutWeather.json": [
		13100,
		3,
		3100
	],
	"./ActionWords": [
		23962,
		3,
		3962
	],
	"./ActionWords.json": [
		23962,
		3,
		3962
	],
	"./AdditionWordProblem": [
		57470,
		3,
		7470
	],
	"./AdditionWordProblem.json": [
		57470,
		3,
		7470
	],
	"./Adjectives": [
		68723,
		3,
		8723
	],
	"./Adjectives.json": [
		68723,
		3,
		8723
	],
	"./AdjectivesClassTwoMCQ": [
		47868,
		3,
		7868
	],
	"./AdjectivesClassTwoMCQ.json": [
		47868,
		3,
		7868
	],
	"./Adverbs": [
		75612,
		3,
		5612
	],
	"./Adverbs.json": [
		75612,
		3,
		5612
	],
	"./AmIsAreWasWereClassTwoMultipleChoice": [
		57286,
		3,
		7286
	],
	"./AmIsAreWasWereClassTwoMultipleChoice.json": [
		57286,
		3,
		7286
	],
	"./AmIsAreWasWereClassTwoTrueFalse": [
		24288,
		3,
		4288
	],
	"./AmIsAreWasWereClassTwoTrueFalse.json": [
		24288,
		3,
		4288
	],
	"./Analogy": [
		58826,
		3,
		8826
	],
	"./Analogy.json": [
		58826,
		3,
		8826
	],
	"./AnimalCrossword": [
		79561,
		3,
		9561
	],
	"./AnimalCrossword.json": [
		79561,
		3,
		9561
	],
	"./AnimalFillInTheBlanks": [
		5607,
		3,
		5607
	],
	"./AnimalFillInTheBlanks.json": [
		5607,
		3,
		5607
	],
	"./AnimalIdentifyOddOneOut": [
		2408,
		3,
		2408
	],
	"./AnimalIdentifyOddOneOut.json": [
		2408,
		3,
		2408
	],
	"./AnimalMultipleChoice": [
		31576,
		3,
		1576
	],
	"./AnimalMultipleChoice.json": [
		31576,
		3,
		1576
	],
	"./AnimalPictureQuestion": [
		89547,
		3,
		9547
	],
	"./AnimalPictureQuestion.json": [
		89547,
		3,
		9547
	],
	"./AnimalSheltersClassTwoMultipleChoice": [
		29732,
		3,
		9732
	],
	"./AnimalSheltersClassTwoMultipleChoice.json": [
		29732,
		3,
		9732
	],
	"./AnimalSheltersClassTwoTrueFalse": [
		46674,
		3,
		6674
	],
	"./AnimalSheltersClassTwoTrueFalse.json": [
		46674,
		3,
		6674
	],
	"./AnimalTrueFalse": [
		86286,
		3,
		3905
	],
	"./AnimalTrueFalse.json": [
		86286,
		3,
		3905
	],
	"./Articles": [
		31608,
		3,
		1608
	],
	"./Articles.json": [
		31608,
		3,
		1608
	],
	"./ArticlesClassOne": [
		22028,
		3,
		2028
	],
	"./ArticlesClassOne.json": [
		22028,
		3,
		2028
	],
	"./ArticlesClassTwoMultipleChoice": [
		96193,
		3,
		6193
	],
	"./ArticlesClassTwoMultipleChoice.json": [
		96193,
		3,
		6193
	],
	"./ArticlesClassTwoTrueFalse": [
		29809,
		3,
		9809
	],
	"./ArticlesClassTwoTrueFalse.json": [
		29809,
		3,
		9809
	],
	"./BodyPartsTrueFalse": [
		46526,
		3,
		6526
	],
	"./BodyPartsTrueFalse.json": [
		46526,
		3,
		6526
	],
	"./BodyPartsforLKG": [
		21292,
		3,
		1292
	],
	"./BodyPartsforLKG.json": [
		21292,
		3,
		1292
	],
	"./CelebrationsClassTwoMultipleChoice": [
		44287,
		3,
		4287
	],
	"./CelebrationsClassTwoMultipleChoice.json": [
		44287,
		3,
		4287
	],
	"./ChooseCorrectHome": [
		41971,
		3,
		1971
	],
	"./ChooseCorrectHome.json": [
		41971,
		3,
		1971
	],
	"./ChooseGender": [
		77839,
		3,
		7839
	],
	"./ChooseGender.json": [
		77839,
		3,
		7839
	],
	"./ClassThree/IGKO": [
		94958,
		3,
		4958
	],
	"./ClassThree/IGKO.json": [
		94958,
		3,
		4958
	],
	"./ClassThree/NSO": [
		17152,
		3,
		7152
	],
	"./ClassThree/NSO.json": [
		17152,
		3,
		7152
	],
	"./ClassThreeEnglish/Adjectives": [
		8310,
		3,
		8310
	],
	"./ClassThreeEnglish/Adjectives.json": [
		8310,
		3,
		8310
	],
	"./ClassThreeEnglish/Adverbs": [
		58567,
		3,
		8567
	],
	"./ClassThreeEnglish/Adverbs.json": [
		58567,
		3,
		8567
	],
	"./ClassThreeEnglish/Conjunctions": [
		58943,
		3,
		8943
	],
	"./ClassThreeEnglish/Conjunctions.json": [
		58943,
		3,
		8943
	],
	"./ClassThreeEnglish/Interjections": [
		30605,
		3,
		605
	],
	"./ClassThreeEnglish/Interjections.json": [
		30605,
		3,
		605
	],
	"./ClassThreeEnglish/Nouns": [
		51247,
		3,
		1247
	],
	"./ClassThreeEnglish/Nouns.json": [
		51247,
		3,
		1247
	],
	"./ClassThreeEnglish/Prepositions": [
		34125,
		3,
		4125
	],
	"./ClassThreeEnglish/Prepositions.json": [
		34125,
		3,
		4125
	],
	"./ClassThreeEnglish/Pronouns": [
		26646,
		3,
		6646
	],
	"./ClassThreeEnglish/Pronouns.json": [
		26646,
		3,
		6646
	],
	"./ClassThreeEnglish/Punctuation": [
		39818,
		3,
		9818
	],
	"./ClassThreeEnglish/Punctuation.json": [
		39818,
		3,
		9818
	],
	"./ClassThreeEnglish/ReadingComprehension": [
		8274,
		3,
		8274
	],
	"./ClassThreeEnglish/ReadingComprehension.json": [
		8274,
		3,
		8274
	],
	"./ClassThreeEnglish/Sentences": [
		46068,
		3,
		6068
	],
	"./ClassThreeEnglish/Sentences.json": [
		46068,
		3,
		6068
	],
	"./ClassThreeEnglish/Tenses": [
		17482,
		3,
		7482
	],
	"./ClassThreeEnglish/Tenses.json": [
		17482,
		3,
		7482
	],
	"./ClassThreeEnglish/Verbs": [
		77088,
		3,
		7088
	],
	"./ClassThreeEnglish/Verbs.json": [
		77088,
		3,
		7088
	],
	"./ClassThreeEnglish/Vocabulary": [
		87190,
		3,
		7190
	],
	"./ClassThreeEnglish/Vocabulary.json": [
		87190,
		3,
		7190
	],
	"./ClassThreeMathematics/Addition": [
		85720,
		3,
		5720
	],
	"./ClassThreeMathematics/Addition.json": [
		85720,
		3,
		5720
	],
	"./ClassThreeMathematics/Division": [
		81035,
		3,
		1035
	],
	"./ClassThreeMathematics/Division.json": [
		81035,
		3,
		1035
	],
	"./ClassThreeMathematics/GeometryMaps": [
		32735,
		3,
		2735
	],
	"./ClassThreeMathematics/GeometryMaps.json": [
		32735,
		3,
		2735
	],
	"./ClassThreeMathematics/Measurements": [
		91361,
		3,
		1361
	],
	"./ClassThreeMathematics/Measurements.json": [
		91361,
		3,
		1361
	],
	"./ClassThreeMathematics/Money": [
		86644,
		3,
		6644
	],
	"./ClassThreeMathematics/Money.json": [
		86644,
		3,
		6644
	],
	"./ClassThreeMathematics/Multiplication": [
		9302,
		3,
		9302
	],
	"./ClassThreeMathematics/Multiplication.json": [
		9302,
		3,
		9302
	],
	"./ClassThreeMathematics/Numbers": [
		67530,
		3,
		7530
	],
	"./ClassThreeMathematics/Numbers.json": [
		67530,
		3,
		7530
	],
	"./ClassThreeMathematics/Subtraction": [
		78702,
		3,
		8702
	],
	"./ClassThreeMathematics/Subtraction.json": [
		78702,
		3,
		8702
	],
	"./ClassThreeMathematics/Time": [
		5893,
		3,
		5893
	],
	"./ClassThreeMathematics/Time.json": [
		5893,
		3,
		5893
	],
	"./ClassThreeScience/AnimalBirds": [
		30016,
		3,
		16
	],
	"./ClassThreeScience/AnimalBirds.json": [
		30016,
		3,
		16
	],
	"./ClassThreeScience/AnimalFoodHabits": [
		32779,
		3,
		2779
	],
	"./ClassThreeScience/AnimalFoodHabits.json": [
		32779,
		3,
		2779
	],
	"./ClassThreeScience/AnimalInsect": [
		8484,
		3,
		8484
	],
	"./ClassThreeScience/AnimalInsect.json": [
		8484,
		3,
		8484
	],
	"./ClassThreeScience/FoodsFromPlant": [
		96534,
		3,
		6534
	],
	"./ClassThreeScience/FoodsFromPlant.json": [
		96534,
		3,
		6534
	],
	"./ClassThreeScience/FormsOfMatter": [
		64443,
		3,
		4443
	],
	"./ClassThreeScience/FormsOfMatter.json": [
		64443,
		3,
		4443
	],
	"./ClassThreeScience/HealthHygine": [
		33536,
		3,
		3536
	],
	"./ClassThreeScience/HealthHygine.json": [
		33536,
		3,
		3536
	],
	"./ClassThreeScience/HumanBody": [
		51357,
		3,
		1357
	],
	"./ClassThreeScience/HumanBody.json": [
		51357,
		3,
		1357
	],
	"./ClassThreeScience/LivingNonLiving": [
		2293,
		3,
		2293
	],
	"./ClassThreeScience/LivingNonLiving.json": [
		2293,
		3,
		2293
	],
	"./ClassThreeScience/NaturalResource": [
		981,
		3,
		981
	],
	"./ClassThreeScience/NaturalResource.json": [
		981,
		3,
		981
	],
	"./ClassThreeScience/SoilProperties": [
		65946,
		3,
		5946
	],
	"./ClassThreeScience/SoilProperties.json": [
		65946,
		3,
		5946
	],
	"./ClassThreeScience/SurroundingPlant": [
		66611,
		3,
		6611
	],
	"./ClassThreeScience/SurroundingPlant.json": [
		66611,
		3,
		6611
	],
	"./ClassThreeScience/WaterResource": [
		98571,
		3,
		8571
	],
	"./ClassThreeScience/WaterResource.json": [
		98571,
		3,
		8571
	],
	"./ClassThreeSocialStudies/CummunityHelpers": [
		94394,
		3,
		4394
	],
	"./ClassThreeSocialStudies/CummunityHelpers.json": [
		94394,
		3,
		4394
	],
	"./ClassThreeSocialStudies/EarthIntroduction": [
		21266,
		3,
		1266
	],
	"./ClassThreeSocialStudies/EarthIntroduction.json": [
		21266,
		3,
		1266
	],
	"./ClassThreeSocialStudies/EnvironmentIntroduction": [
		62519,
		3,
		4900
	],
	"./ClassThreeSocialStudies/EnvironmentIntroduction.json": [
		62519,
		3,
		4900
	],
	"./ClassThreeSocialStudies/IndiaHeritage": [
		6748,
		3,
		6748
	],
	"./ClassThreeSocialStudies/IndiaHeritage.json": [
		6748,
		3,
		6748
	],
	"./ClassThreeSocialStudies/SafetyRules": [
		16899,
		3,
		6899
	],
	"./ClassThreeSocialStudies/SafetyRules.json": [
		16899,
		3,
		6899
	],
	"./ClassThreeSocialStudies/TimeCalender": [
		35885,
		3,
		5885
	],
	"./ClassThreeSocialStudies/TimeCalender.json": [
		35885,
		3,
		5885
	],
	"./ClassThreeSocialStudies/TransportChanges": [
		22940,
		3,
		2940
	],
	"./ClassThreeSocialStudies/TransportChanges.json": [
		22940,
		3,
		2940
	],
	"./ClothsToWearClassTwoMultipleChoice": [
		6825,
		3,
		6825
	],
	"./ClothsToWearClassTwoMultipleChoice.json": [
		6825,
		3,
		6825
	],
	"./ClothsToWearClassTwoTrueFalse": [
		52681,
		3,
		2681
	],
	"./ClothsToWearClassTwoTrueFalse.json": [
		52681,
		3,
		2681
	],
	"./CollectiveNouns": [
		37344,
		3,
		7344
	],
	"./CollectiveNouns.json": [
		37344,
		3,
		7344
	],
	"./CombineSentences": [
		95650,
		3,
		5650
	],
	"./CombineSentences.json": [
		95650,
		3,
		5650
	],
	"./CommonNounsProblem": [
		97674,
		3,
		7674
	],
	"./CommonNounsProblem.json": [
		97674,
		3,
		7674
	],
	"./CommunicationClassTwoFillInTheBlanks": [
		44991,
		3,
		4991
	],
	"./CommunicationClassTwoFillInTheBlanks.json": [
		44991,
		3,
		4991
	],
	"./CommunicationClassTwoMultipleChoice": [
		29696,
		3,
		9696
	],
	"./CommunicationClassTwoMultipleChoice.json": [
		29696,
		3,
		9696
	],
	"./CommunicationClassTwoTrueFalse": [
		24870,
		3,
		4870
	],
	"./CommunicationClassTwoTrueFalse.json": [
		24870,
		3,
		4870
	],
	"./CompoundNounWorksheet": [
		55498,
		3,
		5498
	],
	"./CompoundNounWorksheet.json": [
		55498,
		3,
		5498
	],
	"./ComprehensionClassTwo": [
		63191,
		3,
		3191
	],
	"./ComprehensionClassTwo.json": [
		63191,
		3,
		3191
	],
	"./ConcreteAbstractNounsProblem": [
		31814,
		3,
		1814
	],
	"./ConcreteAbstractNounsProblem.json": [
		31814,
		3,
		1814
	],
	"./Conjunctions": [
		55234,
		3,
		5234
	],
	"./Conjunctions.json": [
		55234,
		3,
		5234
	],
	"./ContractionWorksheet": [
		52379,
		3,
		2379
	],
	"./ContractionWorksheet.json": [
		52379,
		3,
		2379
	],
	"./CorrectNumbers": [
		95559,
		3,
		5559
	],
	"./CorrectNumbers.json": [
		95559,
		3,
		5559
	],
	"./CountableUncountableNouns": [
		63137,
		3,
		3137
	],
	"./CountableUncountableNouns.json": [
		63137,
		3,
		3137
	],
	"./DailyRoutineClassTwoMultipleChoice": [
		23761,
		3,
		3761
	],
	"./DailyRoutineClassTwoMultipleChoice.json": [
		23761,
		3,
		3761
	],
	"./DaysOfWeek": [
		49737,
		3,
		9737
	],
	"./DaysOfWeek.json": [
		49737,
		3,
		9737
	],
	"./DescribingWords": [
		80074,
		3,
		7693
	],
	"./DescribingWords.json": [
		80074,
		3,
		7693
	],
	"./DifferentHouseClassTwoMultipleChoice": [
		98481,
		3,
		8481
	],
	"./DifferentHouseClassTwoMultipleChoice.json": [
		98481,
		3,
		8481
	],
	"./DifferentHouseClassTwoTrueFalse": [
		65025,
		3,
		5025
	],
	"./DifferentHouseClassTwoTrueFalse.json": [
		65025,
		3,
		5025
	],
	"./DivisionWordProblem": [
		28475,
		3,
		8475
	],
	"./DivisionWordProblem.json": [
		28475,
		3,
		8475
	],
	"./DivisionWordProblemClassTwo": [
		74645,
		3,
		4645
	],
	"./DivisionWordProblemClassTwo.json": [
		74645,
		3,
		4645
	],
	"./FestivalsClassTwoMultipleChoice": [
		54485,
		3,
		4485
	],
	"./FestivalsClassTwoMultipleChoice.json": [
		54485,
		3,
		4485
	],
	"./FestivalsClassTwoTrueFalse": [
		29533,
		3,
		9533
	],
	"./FestivalsClassTwoTrueFalse.json": [
		29533,
		3,
		9533
	],
	"./FillBlankCalender": [
		76334,
		3,
		6334
	],
	"./FillBlankCalender.json": [
		76334,
		3,
		6334
	],
	"./FillBlankPronoun": [
		11627,
		3,
		1627
	],
	"./FillBlankPronoun.json": [
		11627,
		3,
		1627
	],
	"./FillBlanksAnimals": [
		82794,
		3,
		2794
	],
	"./FillBlanksAnimals.json": [
		82794,
		3,
		2794
	],
	"./FillBlanksBodyParts": [
		76461,
		3,
		6461
	],
	"./FillBlanksBodyParts.json": [
		76461,
		3,
		6461
	],
	"./FillBlanksHelpers": [
		53594,
		3,
		3594
	],
	"./FillBlanksHelpers.json": [
		53594,
		3,
		3594
	],
	"./FillBlanksLivingNonLiving": [
		85962,
		3,
		5962
	],
	"./FillBlanksLivingNonLiving.json": [
		85962,
		3,
		5962
	],
	"./FillBlanksLivingNonLiving.php": [
		94205,
		1,
		4205
	],
	"./FillBlanksSafety": [
		12267,
		3,
		2267
	],
	"./FillBlanksSafety.json": [
		12267,
		3,
		2267
	],
	"./FillBlanksSeasons": [
		9825,
		3,
		9825
	],
	"./FillBlanksSeasons.json": [
		9825,
		3,
		9825
	],
	"./FillBlanksSenseOrgan": [
		81246,
		3,
		1246
	],
	"./FillBlanksSenseOrgan.json": [
		81246,
		3,
		1246
	],
	"./FillBlanksTransport": [
		80370,
		3,
		370
	],
	"./FillBlanksTransport.json": [
		80370,
		3,
		370
	],
	"./FillBlanksUnscrambleWords": [
		26462,
		3,
		6462
	],
	"./FillBlanksUnscrambleWords.json": [
		26462,
		3,
		6462
	],
	"./FillInTheBlanksAdverbs": [
		66180,
		3,
		6180
	],
	"./FillInTheBlanksAdverbs.json": [
		66180,
		3,
		6180
	],
	"./FillInTheBlanksVerbs": [
		70803,
		3,
		803
	],
	"./FillInTheBlanksVerbs.json": [
		70803,
		3,
		803
	],
	"./FillPrepositionGerunds": [
		50336,
		3,
		336
	],
	"./FillPrepositionGerunds.json": [
		50336,
		3,
		336
	],
	"./FindGerunds": [
		22552,
		3,
		2552
	],
	"./FindGerunds.json": [
		22552,
		3,
		2552
	],
	"./FoodWaterClassTwoMultipleChoice": [
		82319,
		3,
		2319
	],
	"./FoodWaterClassTwoMultipleChoice.json": [
		82319,
		3,
		2319
	],
	"./FoodWaterClassTwoTrueFalse": [
		99851,
		3,
		9851
	],
	"./FoodWaterClassTwoTrueFalse.json": [
		99851,
		3,
		9851
	],
	"./FormSentenceJumbleWords": [
		75102,
		3,
		5102
	],
	"./FormSentenceJumbleWords.json": [
		75102,
		3,
		5102
	],
	"./GenderClassTwoMCQ": [
		40831,
		3,
		831
	],
	"./GenderClassTwoMCQ.json": [
		40831,
		3,
		831
	],
	"./GenderConversion": [
		77094,
		3,
		4713
	],
	"./GenderConversion.json": [
		77094,
		3,
		4713
	],
	"./GoodHabbitsforLKG": [
		11902,
		3,
		1902
	],
	"./GoodHabbitsforLKG.json": [
		11902,
		3,
		1902
	],
	"./GrowingUpClassTwoMultipleChoice": [
		23776,
		3,
		3776
	],
	"./GrowingUpClassTwoMultipleChoice.json": [
		23776,
		3,
		3776
	],
	"./GrowingUpClassTwoTrueFalse": [
		33414,
		3,
		3414
	],
	"./GrowingUpClassTwoTrueFalse.json": [
		33414,
		3,
		3414
	],
	"./HardwareSoftwareClassTwoMultipleChoice": [
		17975,
		3,
		7975
	],
	"./HardwareSoftwareClassTwoMultipleChoice.json": [
		17975,
		3,
		7975
	],
	"./HardwareSoftwareClassTwoTrueFalse": [
		15811,
		3,
		5811
	],
	"./HardwareSoftwareClassTwoTrueFalse.json": [
		15811,
		3,
		5811
	],
	"./HomophonesPractice": [
		60074,
		3,
		74
	],
	"./HomophonesPractice.json": [
		60074,
		3,
		74
	],
	"./IEOClassOneSyllabus/Adjectives": [
		33822,
		3,
		3822
	],
	"./IEOClassOneSyllabus/Adjectives.json": [
		33822,
		3,
		3822
	],
	"./IEOClassOneSyllabus/Adverbs": [
		28799,
		3,
		8799
	],
	"./IEOClassOneSyllabus/Adverbs.json": [
		28799,
		3,
		8799
	],
	"./IEOClassOneSyllabus/AnimalsBabiesSoundsGroups": [
		45483,
		3,
		5483
	],
	"./IEOClassOneSyllabus/AnimalsBabiesSoundsGroups.json": [
		45483,
		3,
		5483
	],
	"./IEOClassOneSyllabus/Articles": [
		57669,
		3,
		7669
	],
	"./IEOClassOneSyllabus/Articles.json": [
		57669,
		3,
		7669
	],
	"./IEOClassOneSyllabus/BasicTenses": [
		20200,
		3,
		200
	],
	"./IEOClassOneSyllabus/BasicTenses.json": [
		20200,
		3,
		200
	],
	"./IEOClassOneSyllabus/Comprehension": [
		20950,
		3,
		950
	],
	"./IEOClassOneSyllabus/Comprehension.json": [
		20950,
		3,
		950
	],
	"./IEOClassOneSyllabus/Conjunctions": [
		78327,
		3,
		8327
	],
	"./IEOClassOneSyllabus/Conjunctions.json": [
		78327,
		3,
		8327
	],
	"./IEOClassOneSyllabus/FeminineAndMasculine": [
		96815,
		3,
		6815
	],
	"./IEOClassOneSyllabus/FeminineAndMasculine.json": [
		96815,
		3,
		6815
	],
	"./IEOClassOneSyllabus/JumbledLetters": [
		76146,
		3,
		6146
	],
	"./IEOClassOneSyllabus/JumbledLetters.json": [
		76146,
		3,
		6146
	],
	"./IEOClassOneSyllabus/Nouns": [
		17271,
		3,
		7271
	],
	"./IEOClassOneSyllabus/Nouns.json": [
		17271,
		3,
		7271
	],
	"./IEOClassOneSyllabus/OddOneOut": [
		14687,
		3,
		4687
	],
	"./IEOClassOneSyllabus/OddOneOut.json": [
		14687,
		3,
		4687
	],
	"./IEOClassOneSyllabus/OneAndMany": [
		23692,
		3,
		3692
	],
	"./IEOClassOneSyllabus/OneAndMany.json": [
		23692,
		3,
		3692
	],
	"./IEOClassOneSyllabus/Opposites": [
		3000,
		3,
		3000
	],
	"./IEOClassOneSyllabus/Opposites.json": [
		3000,
		3,
		3000
	],
	"./IEOClassOneSyllabus/Prepositions": [
		63077,
		3,
		3077
	],
	"./IEOClassOneSyllabus/Prepositions.json": [
		63077,
		3,
		3077
	],
	"./IEOClassOneSyllabus/Pronouns": [
		33694,
		3,
		3694
	],
	"./IEOClassOneSyllabus/Pronouns.json": [
		33694,
		3,
		3694
	],
	"./IEOClassOneSyllabus/Punctuation": [
		53410,
		3,
		3410
	],
	"./IEOClassOneSyllabus/Punctuation.json": [
		53410,
		3,
		3410
	],
	"./IEOClassOneSyllabus/SpokenAndWrittenExpression": [
		2342,
		3,
		2342
	],
	"./IEOClassOneSyllabus/SpokenAndWrittenExpression.json": [
		2342,
		3,
		2342
	],
	"./IEOClassOneSyllabus/Verbs": [
		26904,
		3,
		6904
	],
	"./IEOClassOneSyllabus/Verbs.json": [
		26904,
		3,
		6904
	],
	"./IEOClassOneSyllabus/WordMeanings": [
		7030,
		3,
		7030
	],
	"./IEOClassOneSyllabus/WordMeanings.json": [
		7030,
		3,
		7030
	],
	"./IEOClassOneSyllabus/WordPairs": [
		64127,
		3,
		4127
	],
	"./IEOClassOneSyllabus/WordPairs.json": [
		64127,
		3,
		4127
	],
	"./IEOClassTwoSyllabus/AllChapters": [
		32253,
		3,
		2253
	],
	"./IEOClassTwoSyllabus/AllChapters.json": [
		32253,
		3,
		2253
	],
	"./IEOClassTwoSyllabus/SituationBasedVariation": [
		95652,
		3,
		5652
	],
	"./IEOClassTwoSyllabus/SituationBasedVariation.json": [
		95652,
		3,
		5652
	],
	"./IGKOClassOneSyllabus/CurrentAffairs": [
		50650,
		3,
		650
	],
	"./IGKOClassOneSyllabus/CurrentAffairs.json": [
		50650,
		3,
		650
	],
	"./IGKOClassOneSyllabus/EarthAndEnvironment": [
		46811,
		3,
		6811
	],
	"./IGKOClassOneSyllabus/EarthAndEnvironment.json": [
		46811,
		3,
		6811
	],
	"./IGKOClassOneSyllabus/IndiaAndTheWorld": [
		18750,
		3,
		8750
	],
	"./IGKOClassOneSyllabus/IndiaAndTheWorld.json": [
		18750,
		3,
		8750
	],
	"./IGKOClassOneSyllabus/LanguageAndLiterature": [
		20269,
		3,
		269
	],
	"./IGKOClassOneSyllabus/LanguageAndLiterature.json": [
		20269,
		3,
		269
	],
	"./IGKOClassOneSyllabus/LifeSkills": [
		11547,
		3,
		1547
	],
	"./IGKOClassOneSyllabus/LifeSkills.json": [
		11547,
		3,
		1547
	],
	"./IGKOClassOneSyllabus/MathsFun": [
		74039,
		3,
		4039
	],
	"./IGKOClassOneSyllabus/MathsFun.json": [
		74039,
		3,
		4039
	],
	"./IGKOClassOneSyllabus/MeAndMySurroundings": [
		84815,
		3,
		4815
	],
	"./IGKOClassOneSyllabus/MeAndMySurroundings.json": [
		84815,
		3,
		4815
	],
	"./IGKOClassOneSyllabus/PlantsAndAnimals": [
		40839,
		3,
		839
	],
	"./IGKOClassOneSyllabus/PlantsAndAnimals.json": [
		40839,
		3,
		839
	],
	"./IGKOClassOneSyllabus/ScienceAndTechnology": [
		65830,
		3,
		5830
	],
	"./IGKOClassOneSyllabus/ScienceAndTechnology.json": [
		65830,
		3,
		5830
	],
	"./IGKOClassOneSyllabus/Sports": [
		71776,
		3,
		1776
	],
	"./IGKOClassOneSyllabus/Sports.json": [
		71776,
		3,
		1776
	],
	"./IGKOClassOneSyllabus/TransportAndCommunication": [
		86495,
		3,
		6495
	],
	"./IGKOClassOneSyllabus/TransportAndCommunication.json": [
		86495,
		3,
		6495
	],
	"./IGKOClassTwoSyllabus/CurrentAffairs": [
		96140,
		3,
		6140
	],
	"./IGKOClassTwoSyllabus/CurrentAffairs.json": [
		96140,
		3,
		6140
	],
	"./IGKOClassTwoSyllabus/EarthAndEnvironment": [
		52561,
		3,
		2561
	],
	"./IGKOClassTwoSyllabus/EarthAndEnvironment.json": [
		52561,
		3,
		2561
	],
	"./IGKOClassTwoSyllabus/IndiaAndTheWorld": [
		44748,
		3,
		4748
	],
	"./IGKOClassTwoSyllabus/IndiaAndTheWorld.json": [
		44748,
		3,
		4748
	],
	"./IGKOClassTwoSyllabus/LanguageAndLiterature": [
		48203,
		3,
		8203
	],
	"./IGKOClassTwoSyllabus/LanguageAndLiterature.json": [
		48203,
		3,
		8203
	],
	"./IGKOClassTwoSyllabus/LifeSkills": [
		17165,
		3,
		7165
	],
	"./IGKOClassTwoSyllabus/LifeSkills.json": [
		17165,
		3,
		7165
	],
	"./IGKOClassTwoSyllabus/MathsFun": [
		40669,
		3,
		669
	],
	"./IGKOClassTwoSyllabus/MathsFun.json": [
		40669,
		3,
		669
	],
	"./IGKOClassTwoSyllabus/MeAndMySurroundings": [
		80609,
		3,
		609
	],
	"./IGKOClassTwoSyllabus/MeAndMySurroundings.json": [
		80609,
		3,
		609
	],
	"./IGKOClassTwoSyllabus/PlantsAndAnimals": [
		54757,
		3,
		4757
	],
	"./IGKOClassTwoSyllabus/PlantsAndAnimals.json": [
		54757,
		3,
		4757
	],
	"./IGKOClassTwoSyllabus/ScienceAndTechnology": [
		74872,
		3,
		4872
	],
	"./IGKOClassTwoSyllabus/ScienceAndTechnology.json": [
		74872,
		3,
		4872
	],
	"./IGKOClassTwoSyllabus/Sports": [
		458,
		3,
		458
	],
	"./IGKOClassTwoSyllabus/Sports.json": [
		458,
		3,
		458
	],
	"./IGKOClassTwoSyllabus/TransportAndCommunication": [
		31605,
		3,
		1605
	],
	"./IGKOClassTwoSyllabus/TransportAndCommunication.json": [
		31605,
		3,
		1605
	],
	"./IMOClassOneMultipleChoice": [
		37881,
		3,
		7881
	],
	"./IMOClassOneMultipleChoice.json": [
		37881,
		3,
		7881
	],
	"./IMOClassOneSyllabus/Capacity": [
		79906,
		3,
		9906
	],
	"./IMOClassOneSyllabus/Capacity.json": [
		79906,
		3,
		9906
	],
	"./IMOClassOneSyllabus/ComputationOperations": [
		46015,
		3,
		6015
	],
	"./IMOClassOneSyllabus/ComputationOperations.json": [
		46015,
		3,
		6015
	],
	"./IMOClassOneSyllabus/Length": [
		39962,
		3,
		9962
	],
	"./IMOClassOneSyllabus/Length.json": [
		39962,
		3,
		9962
	],
	"./IMOClassOneSyllabus/Lines": [
		32093,
		3,
		2093
	],
	"./IMOClassOneSyllabus/Lines.json": [
		32093,
		3,
		2093
	],
	"./IMOClassOneSyllabus/Money": [
		52822,
		3,
		2822
	],
	"./IMOClassOneSyllabus/Money.json": [
		52822,
		3,
		2822
	],
	"./IMOClassOneSyllabus/NumberNames": [
		95593,
		3,
		5593
	],
	"./IMOClassOneSyllabus/NumberNames.json": [
		95593,
		3,
		5593
	],
	"./IMOClassOneSyllabus/NumberSense": [
		54731,
		3,
		4731
	],
	"./IMOClassOneSyllabus/NumberSense.json": [
		54731,
		3,
		4731
	],
	"./IMOClassOneSyllabus/Numerals": [
		49837,
		3,
		9837
	],
	"./IMOClassOneSyllabus/Numerals.json": [
		49837,
		3,
		9837
	],
	"./IMOClassOneSyllabus/Patterns": [
		3365,
		3,
		3365
	],
	"./IMOClassOneSyllabus/Patterns.json": [
		3365,
		3,
		3365
	],
	"./IMOClassOneSyllabus/Pictographs": [
		81022,
		3,
		1022
	],
	"./IMOClassOneSyllabus/Pictographs.json": [
		81022,
		3,
		1022
	],
	"./IMOClassOneSyllabus/ShapesAndSolids": [
		13433,
		3,
		3433
	],
	"./IMOClassOneSyllabus/ShapesAndSolids.json": [
		13433,
		3,
		3433
	],
	"./IMOClassOneSyllabus/Temperature": [
		10568,
		3,
		568
	],
	"./IMOClassOneSyllabus/Temperature.json": [
		10568,
		3,
		568
	],
	"./IMOClassOneSyllabus/Time": [
		65435,
		3,
		5435
	],
	"./IMOClassOneSyllabus/Time.json": [
		65435,
		3,
		5435
	],
	"./IMOClassOneSyllabus/Weight": [
		16270,
		3,
		6270
	],
	"./IMOClassOneSyllabus/Weight.json": [
		16270,
		3,
		6270
	],
	"./IMOClassTwoSyllabus/Capacity": [
		55760,
		3,
		5760
	],
	"./IMOClassTwoSyllabus/Capacity.json": [
		55760,
		3,
		5760
	],
	"./IMOClassTwoSyllabus/ComputationOperations": [
		59157,
		3,
		9157
	],
	"./IMOClassTwoSyllabus/ComputationOperations.json": [
		59157,
		3,
		9157
	],
	"./IMOClassTwoSyllabus/Length": [
		60760,
		3,
		760
	],
	"./IMOClassTwoSyllabus/Length.json": [
		60760,
		3,
		760
	],
	"./IMOClassTwoSyllabus/Lines": [
		76255,
		3,
		6255
	],
	"./IMOClassTwoSyllabus/Lines.json": [
		76255,
		3,
		6255
	],
	"./IMOClassTwoSyllabus/Money": [
		42592,
		3,
		2592
	],
	"./IMOClassTwoSyllabus/Money.json": [
		42592,
		3,
		2592
	],
	"./IMOClassTwoSyllabus/NumberNames": [
		61951,
		3,
		1951
	],
	"./IMOClassTwoSyllabus/NumberNames.json": [
		61951,
		3,
		1951
	],
	"./IMOClassTwoSyllabus/NumberSense": [
		89477,
		3,
		9477
	],
	"./IMOClassTwoSyllabus/NumberSense.json": [
		89477,
		3,
		9477
	],
	"./IMOClassTwoSyllabus/Numerals": [
		7871,
		3,
		7871
	],
	"./IMOClassTwoSyllabus/Numerals.json": [
		7871,
		3,
		7871
	],
	"./IMOClassTwoSyllabus/Patterns": [
		91471,
		3,
		1471
	],
	"./IMOClassTwoSyllabus/Patterns.json": [
		91471,
		3,
		1471
	],
	"./IMOClassTwoSyllabus/Pictographs": [
		30884,
		3,
		884
	],
	"./IMOClassTwoSyllabus/Pictographs.json": [
		30884,
		3,
		884
	],
	"./IMOClassTwoSyllabus/ShapesAndSolids": [
		51747,
		3,
		1747
	],
	"./IMOClassTwoSyllabus/ShapesAndSolids.json": [
		51747,
		3,
		1747
	],
	"./IMOClassTwoSyllabus/Temperature": [
		47570,
		3,
		7570
	],
	"./IMOClassTwoSyllabus/Temperature.json": [
		47570,
		3,
		7570
	],
	"./IMOClassTwoSyllabus/Time": [
		51425,
		3,
		1425
	],
	"./IMOClassTwoSyllabus/Time.json": [
		51425,
		3,
		1425
	],
	"./IMOClassTwoSyllabus/Weight": [
		44564,
		3,
		4564
	],
	"./IMOClassTwoSyllabus/Weight.json": [
		44564,
		3,
		4564
	],
	"./IdentifyGerunds": [
		60517,
		3,
		517
	],
	"./IdentifyGerunds.json": [
		60517,
		3,
		517
	],
	"./IndentifyCorrectSentence": [
		23812,
		3,
		3812
	],
	"./IndentifyCorrectSentence.json": [
		23812,
		3,
		3812
	],
	"./InputOutputDeviceClassTwoMultipleChoice": [
		55695,
		3,
		5695
	],
	"./InputOutputDeviceClassTwoMultipleChoice.json": [
		55695,
		3,
		5695
	],
	"./InputOutputDeviceClassTwoTrueFalse": [
		64011,
		3,
		4011
	],
	"./InputOutputDeviceClassTwoTrueFalse.json": [
		64011,
		3,
		4011
	],
	"./KnowComputerClassTwoMultipleChoice": [
		86356,
		3,
		6356
	],
	"./KnowComputerClassTwoMultipleChoice.json": [
		86356,
		3,
		6356
	],
	"./KnowComputerClassTwoTrueFalse": [
		33570,
		3,
		3570
	],
	"./KnowComputerClassTwoTrueFalse.json": [
		33570,
		3,
		3570
	],
	"./LivingNonLivingFillInTheBlanks": [
		38366,
		3,
		8366
	],
	"./LivingNonLivingFillInTheBlanks.json": [
		38366,
		3,
		8366
	],
	"./LivingNonLivingIdentifyOddOneOut": [
		98241,
		3,
		8241
	],
	"./LivingNonLivingIdentifyOddOneOut.json": [
		98241,
		3,
		8241
	],
	"./LivingNonLivingMultipleChoice": [
		67943,
		3,
		7943
	],
	"./LivingNonLivingMultipleChoice.json": [
		67943,
		3,
		7943
	],
	"./LivingNonLivingPictureQuestion": [
		48822,
		3,
		8822
	],
	"./LivingNonLivingPictureQuestion.json": [
		48822,
		3,
		8822
	],
	"./LivingNonLivingTrueFalse": [
		90355,
		3,
		355
	],
	"./LivingNonLivingTrueFalse.json": [
		90355,
		3,
		355
	],
	"./MSWindowClassTwoMultipleChoice": [
		818,
		3,
		818
	],
	"./MSWindowClassTwoMultipleChoice.json": [
		818,
		3,
		818
	],
	"./MSWindowClassTwoTrueFalse": [
		87940,
		3,
		7940
	],
	"./MSWindowClassTwoTrueFalse.json": [
		87940,
		3,
		7940
	],
	"./MatchAnimal": [
		14612,
		3,
		4612
	],
	"./MatchAnimal.json": [
		14612,
		3,
		4612
	],
	"./MatchSeasons": [
		25602,
		3,
		5602
	],
	"./MatchSeasons.json": [
		25602,
		3,
		5602
	],
	"./MatchSenseOrgan": [
		23847,
		3,
		3847
	],
	"./MatchSenseOrgan.json": [
		23847,
		3,
		3847
	],
	"./MeasuringLength": [
		31618,
		3,
		1618
	],
	"./MeasuringLength.json": [
		31618,
		3,
		1618
	],
	"./MeasuringLiquid": [
		52142,
		3,
		2142
	],
	"./MeasuringLiquid.json": [
		52142,
		3,
		2142
	],
	"./MeasuringWeight": [
		17094,
		3,
		7094
	],
	"./MeasuringWeight.json": [
		17094,
		3,
		7094
	],
	"./MissingPunctuation": [
		54595,
		3,
		4595
	],
	"./MissingPunctuation.json": [
		54595,
		3,
		4595
	],
	"./MoneyWordProblem": [
		43352,
		3,
		3352
	],
	"./MoneyWordProblem.json": [
		43352,
		3,
		3352
	],
	"./MonthOfYear": [
		16223,
		3,
		6223
	],
	"./MonthOfYear.json": [
		16223,
		3,
		6223
	],
	"./MultipleChoiceAnimals": [
		29201,
		3,
		9201
	],
	"./MultipleChoiceAnimals.json": [
		29201,
		3,
		9201
	],
	"./MultipleChoiceFestivals": [
		15201,
		3,
		5201
	],
	"./MultipleChoiceFestivals.json": [
		15201,
		3,
		5201
	],
	"./MultipleChoiceHelpers": [
		72417,
		3,
		2417
	],
	"./MultipleChoiceHelpers.json": [
		72417,
		3,
		2417
	],
	"./MultipleChoiceLivingNonLiving": [
		13529,
		3,
		3529
	],
	"./MultipleChoiceLivingNonLiving.json": [
		13529,
		3,
		3529
	],
	"./MultipleChoiceMaterials": [
		17966,
		3,
		7966
	],
	"./MultipleChoiceMaterials.json": [
		17966,
		3,
		7966
	],
	"./MultipleChoicePlants": [
		95786,
		3,
		5786
	],
	"./MultipleChoicePlants.json": [
		95786,
		3,
		5786
	],
	"./MultipleChoiceSafety": [
		21094,
		3,
		1094
	],
	"./MultipleChoiceSafety.json": [
		21094,
		3,
		1094
	],
	"./MultipleChoiceShelter": [
		45661,
		3,
		5661
	],
	"./MultipleChoiceShelter.json": [
		45661,
		3,
		5661
	],
	"./MultipleChoiceTransports": [
		91962,
		3,
		1962
	],
	"./MultipleChoiceTransports.json": [
		91962,
		3,
		1962
	],
	"./MultipleChoiceWeather": [
		15224,
		3,
		5224
	],
	"./MultipleChoiceWeather.json": [
		15224,
		3,
		5224
	],
	"./MultiplicationWord": [
		42321,
		3,
		2321
	],
	"./MultiplicationWord.json": [
		42321,
		3,
		2321
	],
	"./MultiplicationWordProblemClassTwo": [
		95058,
		3,
		5058
	],
	"./MultiplicationWordProblemClassTwo.json": [
		95058,
		3,
		5058
	],
	"./MyHomeTrueFalse": [
		63697,
		3,
		3697
	],
	"./MyHomeTrueFalse.json": [
		63697,
		3,
		3697
	],
	"./NCOClassOneSyllabus/AllChapters": [
		71568,
		3,
		1568
	],
	"./NCOClassOneSyllabus/AllChapters.json": [
		71568,
		3,
		1568
	],
	"./NCOClassTwoSyllabus/AllChapters": [
		97754,
		3,
		7754
	],
	"./NCOClassTwoSyllabus/AllChapters.json": [
		97754,
		3,
		7754
	],
	"./NSOClassOneFillInTheBlanks": [
		2961,
		3,
		2961
	],
	"./NSOClassOneFillInTheBlanks.json": [
		2961,
		3,
		2961
	],
	"./NSOClassOneIdentifyOddOneOut": [
		67538,
		3,
		7538
	],
	"./NSOClassOneIdentifyOddOneOut.json": [
		67538,
		3,
		7538
	],
	"./NSOClassOneMultipleChoice": [
		39314,
		3,
		9314
	],
	"./NSOClassOneMultipleChoice.json": [
		39314,
		3,
		9314
	],
	"./NSOClassOneTrueFalse": [
		11300,
		3,
		1300
	],
	"./NSOClassOneTrueFalse.json": [
		11300,
		3,
		1300
	],
	"./NSOClassTwoSyllabus/AirWaterAndRocks": [
		27231,
		3,
		7231
	],
	"./NSOClassTwoSyllabus/AirWaterAndRocks.json": [
		27231,
		3,
		7231
	],
	"./NSOClassTwoSyllabus/Animals": [
		798,
		3,
		798
	],
	"./NSOClassTwoSyllabus/Animals.json": [
		798,
		3,
		798
	],
	"./NSOClassTwoSyllabus/EarthAndUniverse": [
		62171,
		3,
		2171
	],
	"./NSOClassTwoSyllabus/EarthAndUniverse.json": [
		62171,
		3,
		2171
	],
	"./NSOClassTwoSyllabus/FamilyAndFestivals": [
		45151,
		3,
		5151
	],
	"./NSOClassTwoSyllabus/FamilyAndFestivals.json": [
		45151,
		3,
		5151
	],
	"./NSOClassTwoSyllabus/Food": [
		54221,
		3,
		4221
	],
	"./NSOClassTwoSyllabus/Food.json": [
		54221,
		3,
		4221
	],
	"./NSOClassTwoSyllabus/GoodHabitsAndSafetyRules": [
		93317,
		3,
		3317
	],
	"./NSOClassTwoSyllabus/GoodHabitsAndSafetyRules.json": [
		93317,
		3,
		3317
	],
	"./NSOClassTwoSyllabus/HousingAndClothing": [
		51145,
		3,
		1145
	],
	"./NSOClassTwoSyllabus/HousingAndClothing.json": [
		51145,
		3,
		1145
	],
	"./NSOClassTwoSyllabus/HumanBody": [
		55994,
		3,
		5994
	],
	"./NSOClassTwoSyllabus/HumanBody.json": [
		55994,
		3,
		5994
	],
	"./NSOClassTwoSyllabus/Plants": [
		60059,
		3,
		59
	],
	"./NSOClassTwoSyllabus/Plants.json": [
		60059,
		3,
		59
	],
	"./NSOClassTwoSyllabus/TransportAndCommunication": [
		51905,
		3,
		1905
	],
	"./NSOClassTwoSyllabus/TransportAndCommunication.json": [
		51905,
		3,
		1905
	],
	"./NamingWords": [
		71708,
		3,
		1708
	],
	"./NamingWords.json": [
		71708,
		3,
		1708
	],
	"./NaturalManmadeClassTwoMultipleChoice": [
		19116,
		3,
		9116
	],
	"./NaturalManmadeClassTwoMultipleChoice.json": [
		19116,
		3,
		9116
	],
	"./NaturalManmadeClassTwoTrueFalse": [
		63210,
		3,
		3210
	],
	"./NaturalManmadeClassTwoTrueFalse.json": [
		63210,
		3,
		3210
	],
	"./NeighboursClassTwoMultipleChoice": [
		69494,
		3,
		9494
	],
	"./NeighboursClassTwoMultipleChoice.json": [
		69494,
		3,
		9494
	],
	"./NeighboursClassTwoTrueFalse": [
		28816,
		3,
		8816
	],
	"./NeighboursClassTwoTrueFalse.json": [
		28816,
		3,
		8816
	],
	"./NounsFillBlanks": [
		90494,
		3,
		494
	],
	"./NounsFillBlanks.json": [
		90494,
		3,
		494
	],
	"./NounsProblem": [
		4407,
		3,
		4407
	],
	"./NounsProblem.json": [
		4407,
		3,
		4407
	],
	"./OddOneOutAnimals": [
		90953,
		3,
		953
	],
	"./OddOneOutAnimals.json": [
		90953,
		3,
		953
	],
	"./OddOneOutClothing": [
		64544,
		3,
		4544
	],
	"./OddOneOutClothing.json": [
		64544,
		3,
		4544
	],
	"./OddOneOutFoods": [
		94957,
		3,
		4957
	],
	"./OddOneOutFoods.json": [
		94957,
		3,
		4957
	],
	"./OddOneOutLivingNonLiving": [
		36097,
		3,
		6097
	],
	"./OddOneOutLivingNonLiving.json": [
		36097,
		3,
		6097
	],
	"./OddOneOutPlants": [
		2578,
		3,
		2578
	],
	"./OddOneOutPlants.json": [
		2578,
		3,
		2578
	],
	"./OddOneOutTransports": [
		9538,
		3,
		9538
	],
	"./OddOneOutTransports.json": [
		9538,
		3,
		9538
	],
	"./OppositeWords": [
		74431,
		3,
		4431
	],
	"./OppositeWords.json": [
		74431,
		3,
		4431
	],
	"./OppositeWordsClassTwoMultipleChoice": [
		83086,
		3,
		3086
	],
	"./OppositeWordsClassTwoMultipleChoice.json": [
		83086,
		3,
		3086
	],
	"./OppositeWordsClassTwoTrueFalse": [
		89912,
		3,
		9912
	],
	"./OppositeWordsClassTwoTrueFalse.json": [
		89912,
		3,
		9912
	],
	"./PaintProgramClassTwoMultipleChoice": [
		90302,
		3,
		302
	],
	"./PaintProgramClassTwoMultipleChoice.json": [
		90302,
		3,
		302
	],
	"./PaintProgramClassTwoTrueFalse": [
		25832,
		3,
		5832
	],
	"./PaintProgramClassTwoTrueFalse.json": [
		25832,
		3,
		5832
	],
	"./PartsComputerClassTwoMultipleChoice": [
		12715,
		3,
		2715
	],
	"./PartsComputerClassTwoMultipleChoice.json": [
		12715,
		3,
		2715
	],
	"./PartsComputerClassTwoTrueFalse": [
		55471,
		3,
		5471
	],
	"./PartsComputerClassTwoTrueFalse.json": [
		55471,
		3,
		5471
	],
	"./PatternsClassOneOlympiad": [
		6703,
		3,
		6703
	],
	"./PatternsClassOneOlympiad.json": [
		6703,
		3,
		6703
	],
	"./PeopleHelpUs": [
		4835,
		3,
		4835
	],
	"./PeopleHelpUs.json": [
		4835,
		3,
		4835
	],
	"./PhoneticWords": [
		97772,
		3,
		7772
	],
	"./PhoneticWords.json": [
		97772,
		3,
		7772
	],
	"./PictureComposition": [
		40739,
		3,
		739
	],
	"./PictureComposition.json": [
		40739,
		3,
		739
	],
	"./PossesiveNouns": [
		55879,
		3,
		5879
	],
	"./PossesiveNouns.json": [
		55879,
		3,
		5879
	],
	"./Prepositions": [
		49220,
		3,
		9220
	],
	"./Prepositions.json": [
		49220,
		3,
		9220
	],
	"./PrepositionsClassTwoMultipleChoice": [
		37709,
		3,
		7709
	],
	"./PrepositionsClassTwoMultipleChoice.json": [
		37709,
		3,
		7709
	],
	"./PrepositionsClassTwoTrueFalse": [
		23845,
		3,
		3845
	],
	"./PrepositionsClassTwoTrueFalse.json": [
		23845,
		3,
		3845
	],
	"./Pronoun": [
		77290,
		3,
		7290
	],
	"./Pronoun.json": [
		77290,
		3,
		7290
	],
	"./PronounClassTwoMCQ": [
		56595,
		3,
		6595
	],
	"./PronounClassTwoMCQ.json": [
		56595,
		3,
		6595
	],
	"./ProperNoun": [
		10601,
		3,
		601
	],
	"./ProperNoun.json": [
		10601,
		3,
		601
	],
	"./QuestionWords": [
		18848,
		3,
		8848
	],
	"./QuestionWords.json": [
		18848,
		3,
		8848
	],
	"./ReadingComprehensionWorksheet": [
		78133,
		3,
		8133
	],
	"./ReadingComprehensionWorksheet.json": [
		78133,
		3,
		8133
	],
	"./RewriteParagraph": [
		17389,
		3,
		7389
	],
	"./RewriteParagraph.json": [
		17389,
		3,
		7389
	],
	"./RhymingWords": [
		47818,
		3,
		7818
	],
	"./RhymingWords.json": [
		47818,
		3,
		7818
	],
	"./RightContractions": [
		46298,
		3,
		6298
	],
	"./RightContractions.json": [
		46298,
		3,
		6298
	],
	"./SeasonsforLKG": [
		32348,
		3,
		2348
	],
	"./SeasonsforLKG.json": [
		32348,
		3,
		2348
	],
	"./SenseOrganClassTwoMultipleChoice": [
		29713,
		3,
		9713
	],
	"./SenseOrganClassTwoMultipleChoice.json": [
		29713,
		3,
		9713
	],
	"./SenseOrganClassTwoTrueFalse": [
		20097,
		3,
		97
	],
	"./SenseOrganClassTwoTrueFalse.json": [
		20097,
		3,
		97
	],
	"./SentenceFormation": [
		49829,
		3,
		9829
	],
	"./SentenceFormation.json": [
		49829,
		3,
		9829
	],
	"./SentencePhrasesClassTwo": [
		40738,
		3,
		738
	],
	"./SentencePhrasesClassTwo.json": [
		40738,
		3,
		738
	],
	"./ShapesQuestion": [
		681,
		3,
		681
	],
	"./ShapesQuestion.json": [
		681,
		3,
		681
	],
	"./SimpleFutureTense": [
		96253,
		3,
		6253
	],
	"./SimpleFutureTense.json": [
		96253,
		3,
		6253
	],
	"./SimplePastTense": [
		5956,
		3,
		5956
	],
	"./SimplePastTense.json": [
		5956,
		3,
		5956
	],
	"./SimplePresentTense": [
		3131,
		3,
		3131
	],
	"./SimplePresentTense.json": [
		3131,
		3,
		3131
	],
	"./SingularPlural": [
		12288,
		3,
		2288
	],
	"./SingularPlural.json": [
		12288,
		3,
		2288
	],
	"./SingularPluralClassTwoMCQ": [
		56069,
		3,
		6069
	],
	"./SingularPluralClassTwoMCQ.json": [
		56069,
		3,
		6069
	],
	"./SpellingMCQ": [
		28212,
		3,
		8212
	],
	"./SpellingMCQ.json": [
		28212,
		3,
		8212
	],
	"./SubstractionWordProblem": [
		14995,
		3,
		4995
	],
	"./SubstractionWordProblem.json": [
		14995,
		3,
		4995
	],
	"./SubstractionWordProblemClassTwo": [
		4557,
		3,
		4557
	],
	"./SubstractionWordProblemClassTwo.json": [
		4557,
		3,
		4557
	],
	"./SunMoonStarClassTwoFillInTheBlanks": [
		16286,
		3,
		6286
	],
	"./SunMoonStarClassTwoFillInTheBlanks.json": [
		16286,
		3,
		6286
	],
	"./SunMoonStarClassTwoMultipleChoice": [
		81479,
		3,
		1479
	],
	"./SunMoonStarClassTwoMultipleChoice.json": [
		81479,
		3,
		1479
	],
	"./SunMoonStarClassTwoTrueFalse": [
		38771,
		3,
		8771
	],
	"./SunMoonStarClassTwoTrueFalse.json": [
		38771,
		3,
		8771
	],
	"./TheEarthClassTwoFillInTheBlanks": [
		85054,
		3,
		5054
	],
	"./TheEarthClassTwoFillInTheBlanks.json": [
		85054,
		3,
		5054
	],
	"./TheEarthClassTwoIdentifyOddOneOut": [
		18529,
		3,
		8529
	],
	"./TheEarthClassTwoIdentifyOddOneOut.json": [
		18529,
		3,
		8529
	],
	"./TheEarthClassTwoMultipleChoice": [
		94247,
		3,
		4247
	],
	"./TheEarthClassTwoMultipleChoice.json": [
		94247,
		3,
		4247
	],
	"./TheEarthClassTwoPictureQuestion": [
		23030,
		3,
		3030
	],
	"./TheEarthClassTwoPictureQuestion.json": [
		23030,
		3,
		3030
	],
	"./TheEarthClassTwoTrueFalse": [
		71987,
		3,
		1987
	],
	"./TheEarthClassTwoTrueFalse.json": [
		71987,
		3,
		1987
	],
	"./TheMouseClassTwoMultipleChoice": [
		93800,
		3,
		3800
	],
	"./TheMouseClassTwoMultipleChoice.json": [
		93800,
		3,
		3800
	],
	"./TheMouseClassTwoTrueFalse": [
		69278,
		3,
		9278
	],
	"./TheMouseClassTwoTrueFalse.json": [
		69278,
		3,
		9278
	],
	"./TheVerbsClassTwoMultipleChoice": [
		5397,
		3,
		5397
	],
	"./TheVerbsClassTwoMultipleChoice.json": [
		5397,
		3,
		5397
	],
	"./TheVerbsClassTwoTrueFalse": [
		35133,
		3,
		5133
	],
	"./TheVerbsClassTwoTrueFalse.json": [
		35133,
		3,
		5133
	],
	"./ThisThatTheseThose": [
		67562,
		3,
		7562
	],
	"./ThisThatTheseThose.json": [
		67562,
		3,
		7562
	],
	"./TimeQuestion": [
		41158,
		3,
		1158
	],
	"./TimeQuestion.json": [
		41158,
		3,
		1158
	],
	"./TrafficRulesMultipleChoiceQuestion": [
		10188,
		3,
		188
	],
	"./TrafficRulesMultipleChoiceQuestion.json": [
		10188,
		3,
		188
	],
	"./TrafficRulesPicture": [
		85383,
		3,
		5383
	],
	"./TrafficRulesPicture.json": [
		85383,
		3,
		5383
	],
	"./TrafficRulesTrueFalse": [
		25670,
		3,
		5670
	],
	"./TrafficRulesTrueFalse.json": [
		25670,
		3,
		5670
	],
	"./TransportVehicleFillInTheBlanks": [
		27366,
		3,
		7366
	],
	"./TransportVehicleFillInTheBlanks.json": [
		27366,
		3,
		7366
	],
	"./TransportVehicleIdentifyOddOneOut": [
		35577,
		3,
		5577
	],
	"./TransportVehicleIdentifyOddOneOut.json": [
		35577,
		3,
		5577
	],
	"./TransportVehicleMultipleChoice": [
		16639,
		3,
		6639
	],
	"./TransportVehicleMultipleChoice.json": [
		16639,
		3,
		6639
	],
	"./TransportVehiclePictureQuestion": [
		87374,
		3,
		7374
	],
	"./TransportVehiclePictureQuestion.json": [
		87374,
		3,
		7374
	],
	"./TransportVehicleTrueFalse": [
		55515,
		3,
		5515
	],
	"./TransportVehicleTrueFalse.json": [
		55515,
		3,
		5515
	],
	"./TransportsforLKG": [
		32910,
		3,
		2910
	],
	"./TransportsforLKG.json": [
		32910,
		3,
		2910
	],
	"./TrueFalseAir": [
		58654,
		3,
		8654
	],
	"./TrueFalseAir.json": [
		58654,
		3,
		8654
	],
	"./TrueFalseAnimals": [
		79779,
		3,
		2160
	],
	"./TrueFalseAnimals.json": [
		79779,
		3,
		2160
	],
	"./TrueFalseArticle": [
		55268,
		3,
		5268
	],
	"./TrueFalseArticle.json": [
		55268,
		3,
		5268
	],
	"./TrueFalseClothings": [
		78755,
		3,
		8755
	],
	"./TrueFalseClothings.json": [
		78755,
		3,
		8755
	],
	"./TrueFalseFestivals": [
		72651,
		3,
		2651
	],
	"./TrueFalseFestivals.json": [
		72651,
		3,
		2651
	],
	"./TrueFalseFoods": [
		75327,
		3,
		5327
	],
	"./TrueFalseFoods.json": [
		75327,
		3,
		5327
	],
	"./TrueFalseHelpers": [
		22931,
		3,
		2931
	],
	"./TrueFalseHelpers.json": [
		22931,
		3,
		2931
	],
	"./TrueFalseLivingNonLiving": [
		91007,
		3,
		1007
	],
	"./TrueFalseLivingNonLiving.json": [
		91007,
		3,
		1007
	],
	"./TrueFalseMaterials": [
		69072,
		3,
		9072
	],
	"./TrueFalseMaterials.json": [
		69072,
		3,
		9072
	],
	"./TrueFalseMySchool": [
		22988,
		3,
		2988
	],
	"./TrueFalseMySchool.json": [
		22988,
		3,
		2988
	],
	"./TrueFalsePlants": [
		68960,
		3,
		8960
	],
	"./TrueFalsePlants.json": [
		68960,
		3,
		8960
	],
	"./TrueFalseSafety": [
		50212,
		3,
		212
	],
	"./TrueFalseSafety.json": [
		50212,
		3,
		212
	],
	"./TrueFalseSeasons": [
		29344,
		3,
		9344
	],
	"./TrueFalseSeasons.json": [
		29344,
		3,
		9344
	],
	"./TrueFalseSenseOrgan": [
		88393,
		3,
		8393
	],
	"./TrueFalseSenseOrgan.json": [
		88393,
		3,
		8393
	],
	"./TrueFalseShelter": [
		86535,
		3,
		6535
	],
	"./TrueFalseShelter.json": [
		86535,
		3,
		6535
	],
	"./TrueFalseTransports": [
		6848,
		3,
		6848
	],
	"./TrueFalseTransports.json": [
		6848,
		3,
		6848
	],
	"./TrueFalseWater": [
		15637,
		3,
		5637
	],
	"./TrueFalseWater.json": [
		15637,
		3,
		5637
	],
	"./TrueFalseWeather": [
		84658,
		3,
		4658
	],
	"./TrueFalseWeather.json": [
		84658,
		3,
		4658
	],
	"./UnscrambleWords": [
		91052,
		3,
		1052
	],
	"./UnscrambleWords.json": [
		91052,
		3,
		1052
	],
	"./UseOfComputerClassTwoMultipleChoice": [
		30111,
		3,
		111
	],
	"./UseOfComputerClassTwoMultipleChoice.json": [
		30111,
		3,
		111
	],
	"./UseOfComputerClassTwoTrueFalse": [
		85019,
		3,
		5019
	],
	"./UseOfComputerClassTwoTrueFalse.json": [
		85019,
		3,
		5019
	],
	"./UsingKeyboardClassTwoMultipleChoice": [
		99485,
		3,
		9485
	],
	"./UsingKeyboardClassTwoMultipleChoice.json": [
		99485,
		3,
		9485
	],
	"./UsingKeyboardClassTwoTrueFalse": [
		95925,
		3,
		5925
	],
	"./UsingKeyboardClassTwoTrueFalse.json": [
		95925,
		3,
		5925
	],
	"./Verbs": [
		37931,
		3,
		7931
	],
	"./Verbs.json": [
		37931,
		3,
		7931
	],
	"./WeatherSeasonClassTwoFillInTheBlanks": [
		39768,
		3,
		9768
	],
	"./WeatherSeasonClassTwoFillInTheBlanks.json": [
		39768,
		3,
		9768
	],
	"./WeatherSeasonClassTwoMultipleChoice": [
		33441,
		3,
		3441
	],
	"./WeatherSeasonClassTwoMultipleChoice.json": [
		33441,
		3,
		3441
	],
	"./WeatherSeasonClassTwoTrueFalse": [
		14321,
		3,
		4321
	],
	"./WeatherSeasonClassTwoTrueFalse.json": [
		14321,
		3,
		4321
	],
	"./WillBeShallBeClassTwoMultipleChoice": [
		30416,
		3,
		416
	],
	"./WillBeShallBeClassTwoMultipleChoice.json": [
		30416,
		3,
		416
	],
	"./WordAddition": [
		59779,
		3,
		9779
	],
	"./WordAddition.json": [
		59779,
		3,
		9779
	],
	"./WordBankActivity": [
		59972,
		3,
		9972
	],
	"./WordBankActivity.json": [
		59972,
		3,
		9972
	],
	"./WordSubtraction": [
		72655,
		3,
		2655
	],
	"./WordSubtraction.json": [
		72655,
		3,
		2655
	],
	"./YesterdayTodayTomorrowClassTwoMultipleChoice": [
		83156,
		3,
		3156
	],
	"./YesterdayTodayTomorrowClassTwoMultipleChoice.json": [
		83156,
		3,
		3156
	],
	"./YesterdayTodayTomorrowClassTwoTrueFalse": [
		68770,
		3,
		8770
	],
	"./YesterdayTodayTomorrowClassTwoTrueFalse.json": [
		68770,
		3,
		8770
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 77986;
module.exports = webpackAsyncContext;